import React from 'react';
import classnames from 'classnames';

type VerticalListGroupProps = {
  label?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const VerticalListGroup = ({
  label,
  className,
  children,
  ...props
}: VerticalListGroupProps): React.ReactElement => {
  const classNames = classnames('airtame-vertical-list-group', className);
  return (
    <div className={classNames} {...props}>
      {label && (
        <div className="airtame-vertical-list-group__heading" role="heading">
          {label}
        </div>
      )}
      {children}
    </div>
  );
};
